import Accordion from 'accordion-js';
import Swiper from 'swiper';
import { 
    Navigation,
    Pagination,
    Autoplay,
    Scrollbar,
    EffectFade,
    EffectCoverflow,
} from 'swiper/modules';

export function scrollDirection() {
  
  document.addEventListener("DOMContentLoaded", function(event) {

    let lastScrollTop = 0;
    let scrollTop = window.scrollY;
    let offset = 80;

    window.addEventListener('load', (e) => {
      setTimeout(function(){
        scrollTop = window.scrollY;
        if(scrollTop <= offset) document.body.classList.add('scroll-offset');

        if(scrollTop > offset) {
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }
      },500);
    });
    
    window.addEventListener('scroll', function(e) {
      scrollTop = window.scrollY;

      if (scrollTop > lastScrollTop ) {
        document.body.classList.add('scroll-down');
        document.body.classList.remove('scroll-up');
        
      } else {
        document.body.classList.add('scroll-up');
        document.body.classList.remove('scroll-down'); 
      }

      if(scrollTop <= offset) {
        document.body.classList.add('scroll-offset');
      } else {
        document.body.classList.remove('scroll-offset');
      }

      lastScrollTop = scrollTop;
    });
 
  });

}

export function clickAll(selector, modal = false, swiper = false) {

    let clickEls = document.querySelectorAll(selector);

    if(clickEls === undefined || clickEls === null) return false;
      
    clickEls.forEach(clickEl => {
      
      clickEl.style.cursor = 'pointer';
      
      clickEl.addEventListener('click',function(e){
        
        e.preventDefault();
        e.stopPropagation();

        let href = false;
        let link = clickEl.querySelector('a');
        if(link !== undefined) href = link.getAttribute('href');
        
        if(clickEl.getAttribute('data-href') !== null) href = clickEl.dataset.href;
        if(href === undefined || href === false) return false;
  
        if(modal == true && link !== undefined) {

          let modalLink = link.dataset.modalLink;
          
          if(modalLink.length === undefined || modalLink.length === null) return false;
          
          let modalEl = document.querySelector(modalLink);

          if(modalEl === undefined || modalEl === null) return false;
          
          if(swiper !== false) {
            let postId = clickEl.getAttribute('id');

            let slides = modalEl.querySelectorAll('.swiper-slide');

            if(slides !== undefined) {
              slides.forEach(slide => {
                if(slide.dataset.postId == postId) {
                  let slideIndex = parseInt(slide.dataset.swiperSlideIndex) + 1;
                  if(slideIndex !== undefined) swiper.slideTo(slideIndex,0);
                } 
                
              });
            }
          }
          
          modalEl.classList.add('afg-active');
          
        } else {

          window.location = href;

        }
      });

    });

}

export function modals(selector = '.afg-modal-link') {

  let links = document.querySelectorAll(selector);

  links.forEach( link => {
    
    var active = false;
    var modalId = link.dataset.href;
    var modal = document.querySelector(modalId);
    
    link.addEventListener("click", function(e){
      e.preventDefault();
      if(modal !== undefined && modal !== null) {
        if(active == false) {
          modal.classList.add('afg-active');
          this.classList.add('afg-active');
          active = true;
        } else {
          modal.classList.remove('afg-active');
          this.classList.remove('afg-active');
          active = false;
        }
      }

    }, false);
    let modalClose = modal.querySelector('.afg-modal-close');
    if(modalClose !== undefined && modalClose !== null) {
      modalClose.addEventListener("click", function(e){
          e.preventDefault();
          modal.classList.remove('afg-active');
          active = false;
        });
    }

  });


}

export function popups(selector = '.afg-modal.popup',timeBefore = false,timeActive = false) {

  let modals = document.querySelectorAll(selector);
  
  if(modals === undefined || modals === null) return;
  
  let overlay = document.createElement('div');
  overlay.classList.add('afg-modal-overlay');
  
  modals.forEach( modal => {
    
    if(modal.classList.contains('full-screen')) {
       document.body.appendChild(modal);
    }

    if(modal.classList.contains('afg-active')) {
        overlay.classList.add('afg-active');
    }

    let newOverlay = overlay.cloneNode();
    let parent = modal.parentNode;
    newOverlay.id = 'overlay-' + modal.id;
    parent.insertBefore(newOverlay, modal);
      

    if(timeBefore || timeBefore === '0') {
      setTimeout(function(){
        modal.classList.add('afg-active')
        newOverlay.classList.add('afg-active');
      },parseInt(timeBefore));
    }

    if(timeActive && timeActive !== '0') {
      if(timeBefore && timeBefore !== '0') timeActive = parseInt(timeBefore) + parseInt(timeActive);
      setTimeout(function(){
        modal.classList.remove('afg-active')
        newOverlay.classList.remove('afg-active');
      },parseInt(timeActive));
    }

    let modalClose = modal.querySelector('.afg-modal-close');
    if(modalClose !== undefined && modalClose !== null) {
      modalClose.addEventListener("click", function(e){
          e.preventDefault();
          modal.classList.remove('afg-active');
          newOverlay.classList.remove('afg-active');
      });
    }

  });

}

export function scrollToAnchor(link)  {

  jQuery(document).ready(function($){

    $(link).click(function(e){
        let href = $(this).attr('href');
        if(href !== undefined && href !== null) {
            e.preventDefault();
            let el = $('[data-js-id="'+href+'"]');
            var offsetTop = 150;
            if(el !== undefined && el !== null) $('html,body').animate({scrollTop: el.offset().top - offsetTop},'slow');
        }
    });

  });
  
  /*let links = document.querySelectorAll(anchor);

  if(links === undefined) return false;
  
  links.forEach(link => {
    link.addEventListener('click',function(e){

      let anchor = this.getAttribute('href');
      if(anchor === undefined) return false;
      
      let el = document.querySelector(anchor);
      if(el === undefined) return false;
      
      let elTop = el.getBoundingClientRect().top + window.scrollY;
      let offsetTop = 80;
      window.scrollTo({
        top: elTop + offsetTop,
        left:0,
        behavior: 'smooth'
      });

    });
  });*/
}

export function simpleMouse(elementId) {

  let element = document.getElementById(elementId);
  if(element === undefined || element === null ) return false;
  
  let elementFollow = element.querySelector('.afg-mouse-follow');
  if(elementFollow === undefined || elementFollow === null ) return false;
  
  let elementFollowClone = elementFollow.cloneNode(true);
  let parentSection = element.closest('.afg-mouse-follow-wrapper');
  if(parentSection === undefined || parentSection === null ) return false;
  parentSection.append(elementFollowClone);
  let parentSectionPosition = parentSection.getBoundingClientRect();

  let offsetY = 45 - parentSectionPosition.top;
  let offsetX = 45 - parentSectionPosition.left;
  
  element.addEventListener('mouseover', function(e){
    elementFollowClone.style.opacity = '1';
  });
  element.addEventListener('mouseout', function(e){
    elementFollowClone.style.opacity = '0';
  });
  element.addEventListener('mousemove', function(e){
    let x = e.pageX + offsetX;
    let y = e.pageY + offsetY; 
    elementFollowClone.style.left = x + 'px';
    elementFollowClone.style.top = y + 'px';
  });
}

export function stars(selector) {
  
  let ratings = document.querySelectorAll(selector);
  
  if(!ratings) {
    return;
  }

  ratings.forEach(rating => {
    const nextElement = rating.nextElementSibling
    
    if(exists(nextElement)) {
      if(nextElement.classList.contains('.stars')) {
        return;
      }
    }

    let stars = document.createElement('span');
    stars.classList.add('stars');
    let string = rating.textContent;
    
    if(!string.length) {
      return;
    }
      
    let html = '';
    let numbers = string.split('.');

    if(numbers[0]) {
      let fullStars = parseInt(numbers[0]);
      if(false === isNaN(fullStars)) {
      for(let i = 0; i < fullStars; i++) {
          html += '<span class="star" style="background-size:100% 100%;"></span>';
        }
      }
    }
    
    if(numbers[1]) {
      let decimal = parseInt(numbers[1]);
      if(false === isNaN(decimal)) {
        let backgroundWidth = decimal < 10 ? decimal * 10 : decimal;
        let cssProp = 'background-size:'+backgroundWidth.toString()+'% 100%;';
        html += '<span class="star" style="'+cssProp+'"></span>';
      }
    }
    stars.innerHTML = '';
    stars.innerHTML = html;
    rating.after(stars);
  
  });

}

export function blogActions(selector) {
  let blog = document.querySelectorAll(selector)[0];
  let nav =  blog.querySelector('nav ul');

  blogOrder(blog);
  blogNavScrollLeft(blog,nav);

}

function blogOrder(blog) {
  
  let orderButton = blog.querySelector('.afg-action.order-post');
  if(orderButton === null || orderButton === undefined) return;
  
  let sort = false;
  orderButton.addEventListener('click',function(e) {
      e.preventDefault();
      if(sort == false) {
        blog.classList.add('asc');
        sort = true;
      } else {
        blog.classList.remove('asc');
        sort = false;
      }
  });

}

function blogNavScrollLeft(blog,nav) {
  let left = 0;
  if(nav === null || nav === undefined) return;
  let navElements = nav.querySelectorAll('li');
  if(navElements === null || navElements === undefined) return;
  let navWidth = 0;
  navElements.forEach(navElement => {
    navWidth += navElement.offsetWidth;
  });
  navWidth += 80;//Nav left padding

  let forwardButton = blog.querySelector('.afg-action.forward');

  if(forwardButton !== null && forwardButton !== undefined) {
    forwardButton.addEventListener('click',function(e) {
      e.preventDefault();
      left += (navWidth / 4);
      if(left >= navWidth) left = 0;
      nav.scroll({
        left: left,
        behavior: 'smooth',
      });
    });
  }
}

export function textImages() {
  let imageLinks = document.querySelectorAll('.text-content-wrapper a[href^="#theme-image-block"]');
  if(imageLinks === null || imageLinks === undefined) return;
  if(imageLinks.length === 0) return;

  imageLinks.forEach(imageLink => {
    let link = imageLink.getAttribute('href');
    if(link === null || link === undefined) return;

    let image = document.querySelector(link);
    if(image === null || image === undefined) return;

    imageLink.closest('p').style.marginBottom = 0;

    imageLink.addEventListener('click',function(e) {
      e.preventDefault();
    });

    imageLink.addEventListener('mouseenter',function(e) {
      setTimeout(function(){
        image.classList.add('afg-active');
      },100);
    });

    imageLink.addEventListener('mouseleave',function(e) {
      setTimeout(function(){
        image.classList.remove('afg-active');
      },100);
    });

    image.addEventListener('mouseenter',function(e) {
      setTimeout(function(){
        if(image.classList.contains('afg-active') === false) image.classList.add('afg-active');
      },100);
    });

    image.addEventListener('mouseleave',function(e) {
      setTimeout(function(){
        if(image.classList.contains('afg-active')) image.classList.remove('afg-active');
      },100);
    });
    
  });

}

export function swiperWrapper(selector, args = []) {
  if(!exists(selector)) return;
  if(!exists(args)) args = [];
  Swiper.use([Navigation, Pagination, Autoplay, Scrollbar, EffectFade, EffectCoverflow]);

  return new Swiper(selector, args);
  }

export function exists(el) {
  if(el === undefined || el === null) return false;
  if(el.length === 0) return false;
  return true;
}

export function valueExists(value) {
  if(value === undefined || value === null) return false;
  if(value === '') return false;
  if(value === 0) return false;
  if(value === '0') return false;
  return true;
}

export function toggleClass(el,className) {
  if(!exists(el)) return false;
  if(el.classList.contains(className)) {
    el.classList.remove(className);
    return false;
  } else {  
    el.classList.add(className);
    return true;
  }
}

export function toggleClasses(el,class1,class2) {

  if(!exists(el)) return false;
  if(el.classList.contains(class1)) {
    el.classList.add(class2);
    el.classList.remove(class1);
    return;
  } 
  if(el.classList.contains(class2)) {  
    el.classList.remove(class2);
    el.classList.add(class1);
    return;
  }
}

export function createElement(tag, id = false, className = false, content = false) {
  let el = document.createElement(tag);
  if(id) el.id = id;
  if(className) el.classList.add(className);
  if(content) el.innerHTML = content;
  return el;
}


export function moveToBody(el, prepend = false) {
  if (document.querySelector(`body #${el.id}`)) return;
  if (prepend) {
    document.body.prepend(el);
    return;
  }
  document.body.appendChild(el);
}

export function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

export function fetchAjax(action, datas, nonce, callBack, that = null, beforeSend = false, complete = false) {

  const fetchDatas = new FormData();
  fetchDatas.append( 'action', action );
  fetchDatas.append( 'nonce', nonce );
  fetchDatas.append( 'datas', datas );


  const requestOptions = {
      method: 'POST',
      body: fetchDatas
  };
  
  beforeSend && beforeSend(that);
  
  fetch(acseoTheme.url, requestOptions)
    .then(response => {
        if (!response.ok) {
            console.error(response);
            throw new Error(response.text());
        }
        return response.text();
    })
    .then(responseText => {
        callBack && callBack(responseText, datas, that); 
    })
    .catch(error => {
        console.error("Fetch error:", error);
    })
    .finally(() => {
        complete && complete(that);
  });

}

export function onlyNumbers(e){//i.e.: clean html from counter or price elements
  return parseInt(e.replace(/[^0-9]/g,""));
}

export function arraySearch(value, array) {

  for(var key in array) { 
    if(typeof(array[key]) == 'object') {
      if(array[key].includes(value)) return true;
    }
    if(typeof(array[key]) == 'string') {
      if(array[key] == value) return true;
    }
  }
  return false;

}

export function setAccordions({//accordion-js does not work properly with custom selectors
  accordionSelector = null,
  itemsSelector = null,
  triggerSelector = null,
  panelSelector = null,
  reset = false,
}) {

  if(!exists(itemsSelector) || triggerSelector == null || panelSelector == null) return;
  const items = document.querySelectorAll(itemsSelector);
  if(!exists(items)) return;

  items.forEach(el => {//accordion-js does not work properly with custom selectors
  
      if(el.hasOwnProperty('diplay')) {
        if(cssComputedProperty(el, 'display') == 'none') {
          return;
        }
      }  
      
      let trigger = el.querySelector(triggerSelector);
      let panel = el.querySelector(panelSelector);
      if(!exists(trigger) || !exists(panel)) return;

      if(!el.classList.contains('ac')) el.classList.add('ac');
      if(!trigger.classList.contains('ac-trigger')) trigger.classList.add('ac-trigger');
      if(!panel.classList.contains('ac-panel')) panel.classList.add('ac-panel');

      if(reset !== false) {
        el.classList.remove('ac');
        trigger.classList.remove('ac-trigger');
        panel.classList.remove('ac-panel');
      }
  });

  new Accordion(accordionSelector, {
    duration: 400,
    showMultiple: false,
  });
}


/**
* 
* @param el "HTMLElement"
* @param viewportOrigin "%" | "100" | "0"
* @param elOrigin "center" | "top" | "bottom"
* @param tolerance "px"
* @returns boolean
*/
export function isElementInViewport(el, viewportOrigin = 100, elOrigin = 'center', tolerance = 0) {
if(!exists(el)) return false;

const rect = el.getBoundingClientRect();
const windowHeight = window.innerHeight || document.documentElement.clientHeight;
viewportOrigin = viewportOrigin === 0 ? 0 : windowHeight * (viewportOrigin / 100);

if(elOrigin === 'center') elOrigin = (rect.top + rect.bottom) / 2;
if(elOrigin === 'top') elOrigin = rect.top;
if(elOrigin === 'bottom') elOrigin = rect.bottom;

if(Math.abs(elOrigin) < (windowHeight - viewportOrigin + tolerance)) return true;
return false;
}

export function toggleSiblings(el, siblings, className = acseoPlugin.blogActiveCssClass) {
  if(!exists(el)) return;
  if(!exists(siblings)) return;
  siblings.forEach(sibling => {
      if(sibling != el) sibling.classList.remove(className);
  });

  toggleClass(el,className);
}

export function appendNodeList(parentEl, nodeList) {
  if (!exists(nodeList) || !exists(parentEl)) return;
  nodeList.forEach(function (node) {
      parentEl.appendChild(node);
  });  
}

export function copyToClipboard(selector = 'button.copy, .button.copy') {

    let buttons = document.querySelectorAll(selector);

    if(!exists(buttons)) return;
    
    buttons.forEach(button => {
        button.addEventListener('click',function(e){
          e.preventDefault();
          e.stopPropagation();
          
          if(!this.dataset.value) return;
          
          let content = this.dataset.value;
          let parent = this.parentElement;
          let copyTextarea = document.createElement("textarea");
          copyTextarea.style.position = "fixed";
          copyTextarea.style.opacity = "0";
          copyTextarea.textContent = content;
      
          document.body.appendChild(copyTextarea);
          copyTextarea.select();
          document.execCommand("copy");//No replacement for this command
          parent.classList.add(acseoPlugin.blogActiveCssClass);
          setTimeout(function(){
            parent.classList.remove(acseoPlugin.blogActiveCssClass);
          },1000);
          document.body.removeChild(copyTextarea);
      });
    });
    
  }


export function currentPostId() {
  let postId = false;
  
  if(exists(acseoPlugin)) {
    if(exists(acseoPlugin.postId)) return onlyNumbers(acseoPlugin.postId);
  } 

  let datas = false;
  if(datas = editorDatas()) return onlyNumbers(datas.getCurrentPostId());
  
  document.body.classList.forEach(className=>{
      if(className.includes('page-id-')) postId = className.split('-')[2];
      if(postId) return onlyNumbers(postId);
  });

  return false;
}

export function extendLinkToItem(selector) {
  document.addEventListener("DOMContentLoaded", function(event) {
    const items = document.querySelectorAll(selector);
    if(!items) return;
    items.forEach(item => {
      const link = item.querySelector('a');
      if(!link) return;
      const url = link.getAttribute('href');
      if(!url) return;
      item.classList.add('clickable');
      item.addEventListener('click', function(e) {
        window.location.href = url;
      });

    });
  });
}